<template>
  <v-container class="pa-0 ma-0 audit-log-form">
    <v-card :loading="isLoading" style="height: 100vh">
      <v-card-title class="d-flex align-center audit-log-form__header">
        <slot name="title">
          <span class="body-1">{{ title }}</span>
        </slot>
        <v-spacer />
        <v-btn
          icon
          class="ml-2"
          @click="$emit('close')"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-container v-if="!isLoading" class="px-4">
        <slot name="toolbar" />
        <div
          v-if="!entries.length"
          class="grey--text text-center py-8"
        >
          {{ emptyText }}
        </div>
        <v-list v-else>
          <v-list-item
            v-for="(logEntry, index) in entries"
            :key="logEntry.audit_log_id ?? index"
            :class="{ 'mt-2': index > 0 }"
            class="audit-log-form__item"
          >
            <v-list-item-content>
              <v-list-item-title>
                Changes
              </v-list-item-title>
              <v-list-item-subtitle style="white-space: initial;">
                <ul>
                  <li
                    v-for="(change, changeIndex) in getChanges(logEntry)"
                    :key="changeIndex"
                    v-text="change"
                  />
                </ul>
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                <span class="d-inline-flex align-center" style="gap: 0.25rem;">
                  By:
                  <span class="primary--text font-weight-medium">{{ logEntry.author || '—' }}</span>
                </span>
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action class="caption">
              {{ logEntry.created }}
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
  export default {
    name: 'AuditLog',
    props: {
      isLoading: {
        type: Boolean,
        default: false,
      },
      title: {
        type: String,
        default: 'Audit Log',
      },
      entries: {
        type: Array,
        default: () => [],
      },
      getChanges: {
        type: Function,
        required: true,
      },
      emptyText: {
        type: String,
        default: 'No audit log entries',
      },
    },
    emits: ['close'],
  }
</script>

<style lang="scss" scoped>
  .audit-log-form {
    &__header {
      padding: 11px 16px;
    }

    &__item {
      background-color: #fafafa;
    }

    &__filters {
      gap: 16px;
    }
  }
</style>
